import { ComponentType, createContext, ForwardRefExoticComponent, RefAttributes } from 'react';

export interface WizardStateUpdate<T> {
  state: T;
  isValid: boolean;
}

export interface StepConfig {
  label: string;
  description?: string;
  component: ForwardRefExoticComponent<RefAttributes<WizardRef>>;
  actions?: ComponentType;
}

export type ValidCallback = (data: unknown) => Promise<void>;

export type WizardRef = {
  onSubmit: () => Promise<boolean>;
};

export interface WizardContext<T> {
  state: T;
  loading: boolean;
  nextStep: () => void;
  previousStep: () => void;
  reset: () => void;
  updateState: (partialState: Partial<T>) => void;
  setLoading: (loading: boolean) => void;
  triggerFormSubmission: WizardRef['onSubmit'];
  onClose: () => void;
  onError: (error: any) => void;
}

// Initialize with noop functionality
export const WizardState = createContext<WizardContext<any> | null>(null);
